import { z } from 'zod';

export const EmailGroupKey = z.union([
  z.literal('welcome-letter'),
  z.literal('first-payment-due'),
  z.literal('goodbye-letter'),
  z.literal('statement-due'),
  z.literal('revised-statement-available'),
  z.literal('payment-reminder'),
  z.literal('payment-past-due'),
  z.literal('payment-past-grace-period'),
  z.literal('autopay-enabled-disabled'),
  z.literal('loan-is-maturing'),
  z.literal('payoff-quote-available'),
  z.literal('payoff-quote-available-attached'),
  z.literal('external-payoff-quote'),
  z.literal('payoff-payment-posted'),
  z.literal('rescind-goodbye-letter'),
  z.literal('principal-modification-applied-cancelled'),
  z.literal('new-document-available'),
  z.literal('1098-tax-form-available'),
  z.literal('escrow-analysis-available'),
  z.literal('default-interest-applied'),
  z.literal('final-payment-due'),
  z.literal('payment-deferment-plan-cancelled'),
  z.literal('borrower-documentation-for-payment-provider'),
  z.literal('portal-login-instructions'),
  z.literal('borrower-insurance-expiring'),
  z.literal('borrower-insurance-expired'),
]);
export type EmailGroupKey = z.infer<typeof EmailGroupKey>;

export type EmailTemplateKey =
  | 'welcome'
  | 'welcomeInterestReserve'
  | 'welcomeAutoPay'
  | 'goodbye'
  | 'goodbyeBeforeWelcome'
  | 'nextStatementAvailable'
  | 'nextStatementAvailableInterestReserve'
  | 'nextStatementAvailableAutopay'
  | 'borrowerRevisedStatement'
  | 'paymentReminder'
  | 'paymentReminderAutopay'
  | 'paymentPastDueReminder'
  | 'latePayment'
  | 'autopayEnabled'
  | 'autopayDisabled'
  | 'loanIsMaturing'
  | 'payoffQuote'
  | 'externalPayoffQuote'
  | 'externalPayoffQuoteAttached'
  | 'paidInFullStatement'
  | 'partialPayoffConfirmation'
  | 'rescindGoodbye'
  | 'principalModificationApplied'
  | 'principalModificationCancelled'
  | 'newDocumentAvailable'
  | 'form1098Available'
  | 'escrowAnalysisAvailable'
  | 'borrowerDelinquentInterestApplied'
  | 'finalPayment'
  | 'defermentCancelled'
  | 'borrowerDocumentationRequired'
  | 'borrowerDocumentationAdded'
  | 'borrowerDocumentationRejected'
  | 'borrowerDocumentationApprovedEmail'
  | 'portalInstructions'
  | 'borrowerInsuranceExpiring'
  | 'borrowerInsuranceExpired';

export const EMAIL_TEMPLATE_TO_EMAIL_GROUP: Record<EmailTemplateKey, EmailGroupKey> = {
  welcome: 'first-payment-due',
  welcomeInterestReserve: 'first-payment-due',
  welcomeAutoPay: 'first-payment-due',
  goodbye: 'goodbye-letter',
  goodbyeBeforeWelcome: 'goodbye-letter',
  nextStatementAvailable: 'statement-due',
  nextStatementAvailableInterestReserve: 'statement-due',
  nextStatementAvailableAutopay: 'statement-due',
  borrowerRevisedStatement: 'revised-statement-available',
  paymentReminder: 'payment-reminder',
  paymentReminderAutopay: 'payment-reminder',
  paymentPastDueReminder: 'payment-reminder',
  latePayment: 'payment-past-due',
  autopayEnabled: 'autopay-enabled-disabled',
  autopayDisabled: 'autopay-enabled-disabled',
  loanIsMaturing: 'loan-is-maturing',
  payoffQuote: 'payoff-quote-available',
  externalPayoffQuote: 'payoff-quote-available',
  externalPayoffQuoteAttached: 'payoff-quote-available-attached',
  paidInFullStatement: 'payoff-payment-posted',
  partialPayoffConfirmation: 'payoff-payment-posted',
  rescindGoodbye: 'rescind-goodbye-letter',
  principalModificationApplied: 'principal-modification-applied-cancelled',
  principalModificationCancelled: 'principal-modification-applied-cancelled',
  newDocumentAvailable: 'new-document-available',
  form1098Available: '1098-tax-form-available',
  escrowAnalysisAvailable: 'escrow-analysis-available',
  borrowerDelinquentInterestApplied: 'default-interest-applied',
  finalPayment: 'final-payment-due',
  defermentCancelled: 'payment-deferment-plan-cancelled',
  borrowerDocumentationRequired: 'borrower-documentation-for-payment-provider',
  borrowerDocumentationAdded: 'borrower-documentation-for-payment-provider',
  borrowerDocumentationRejected: 'borrower-documentation-for-payment-provider',
  borrowerDocumentationApprovedEmail: 'borrower-documentation-for-payment-provider',
  portalInstructions: 'portal-login-instructions',
  borrowerInsuranceExpiring: 'borrower-insurance-expiring',
  borrowerInsuranceExpired: 'borrower-insurance-expired',
};
